export default __webpack_public_path__ + "static/media/star-empty.4ac0aa8d.svg";